import { render, staticRenderFns } from "./invitations.list.vue?vue&type=template&id=e12018c6&scoped=true&"
import script from "./invitations.list.vue?vue&type=script&lang=js&"
export * from "./invitations.list.vue?vue&type=script&lang=js&"
import style0 from "./invitations.list.vue?vue&type=style&index=0&id=e12018c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12018c6",
  null
  
)

export default component.exports